// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"F1-z","sponsoredTooltipWrapper":"G1-z","sponsoredTooltip":"H1-z","newCard":"I1-z"};